module.exports = __webpack_public_path__ + "media/images/career_camp/2022/home_moon-d9709a174818b57835e2bf894681af42.svg";